export default __webpack_public_path__ + "static/media/apr2024-3.cb74d5d3.jpg";